<script>
    // -- IMPORTS

    import { onMount } from 'svelte';
    import { writable } from 'svelte/store';
    import CardGroupBlock from './cardGroupBlock.svelte';
    import Button from '../element/Button.svelte';

    // -- VARIABLES

    let { data = [], AddNewLabel = '', saveCardArray } = $props();
    let arrayData = writable( data ?? [] );
    let cardArrayState = $state( [] );

    let initialCardData =
        {
            id : '',
            slug : 'new',
            typeSlug : 'card-group',
            number : 0,
            title : null,
            text : null,
            textArray: [],
            mediaPath : '',
            mediaPathArray : [],
            imageFit : null,
            imageHorizontalPosition : null,
            imageVerticalPosition : null,
            imageSide: 'right',
        }

    // -- FUNCTIONS

    function handleAddItem(
        )
    {
        cardArrayState = [ ...cardArrayState, initialCardData ];
    }

    // ~~

    function handleRemoveItem(
        index
        )
    {
        cardArrayState.splice( index, 1 );
    }

    // -- STATEMENTS

    onMount(() => {
        arrayData.subscribe(
            ( value ) =>
            {
                cardArrayState = value.map( ( item ) => item )
            }
            );
    });

    // ~~

    $effect(() => {
        saveCardArray( { cardArray: cardArrayState } ); 
    });
</script>

<style lang="stylus">
    p
    {
        margin: 0;

        align-items: center;

        text-align: center;
    }
    .editor-container
    {
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 10px;

        & + &
        {
            margin-top: 2rem;
        }
    }

    .editor-content
    {
        margin: 0.5rem 0;

        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 1rem;
        align-items: center;
        column-gap: 0.5rem;
    }

    .text-array-container
    {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .buttons-container
    {
        margin-top: 1rem;

        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        justify-content: space-between;
    }
</style>

<div>
    {#each cardArrayState as card, index }
        <div class="editor-container">
            <div class="text-array-container">     
                <h3>{ index }</h3>
                
                <CardGroupBlock blockData={ card } number={ index } />
            </div>

            <div class="buttons-container">
                <Button
                    fullWidth
                    variant="error"
                    type="button"
                    style={"grid-column: 1/-1;"}
                    onclick={ () => handleRemoveItem( index ) }
                >
                    Remove Item
                </Button>
            </div>
        </div>
    {/each}
    
    {#if cardArrayState.length <= 5 }
        <Button
            fullWidth
            type="button"
            style={"margin-top: 1.5rem;"}
            onclick={ handleAddItem }
        >
            { AddNewLabel || 'Add Item'}
        </Button>
    {/if}
</div>
